export const product = {
    state: () => ({
        position: 1,
        variantId: 0,
        fromCheckout: false,
        isRank: false,
        list: {}, 
        topSortAttributes: {},
        sort: {
            previous: '',
            current: '',
            by: '',
            lastSlug: ''
        }
    }),

    getters: {
        getProPosition: (state) => state.position,
        getVarID: (state) => state.variantId,
        getFromCheckOut: (state) => state.fromCheckout,
        getIsRank: (state) => state.isRank,
        getList: (state) => state.list,
        getTopSortAttributes: (state) => state.topSortAttributes,
        getSort: (state) => state.sort,
    },

    actions: {
        setProPosition({ commit }, data) {
            commit('SET_PRODUCT_POSITION', data);
        },
        setVarID({ commit }, data) {
            commit('SET_VARIANT_ID', data);
        },
        setFromCheckOut({ commit }, data) {
            commit('SET_FROM_CHECKOUT', data);
        },
        setIsRank({ commit }, data) {
            commit('SET_IS_RANK', data);
        },
        setList({ commit }, data) {
            commit('SET_LIST', data);
        },
        setProduct({ commit }, data) {
            commit('SET_PRODUCT', data);
        },
        setTopSortAttributes({ commit }, data) {
            commit('SET_TOPSORT_ATTRIBUTES', data);
        },
        setSort({ commit }, data) {
            commit('SET_SORT', data);
        },
    },
    
    mutations: {
        SET_PRODUCT_POSITION(state, data) {
            state.position = data
        },
        SET_VARIANT_ID(state, data) {
            state.variantId = data
        },
        SET_FROM_CHECKOUT(state, data) {
            state.fromCheckout = data
        },
        SET_IS_RANK(state, data) {
            state.isRank = data
        },
        SET_LIST(state, data) {
            state.list = data
        },
        SET_PRODUCT(state, data) {
            state.product = data
        },
        SET_TOPSORT_ATTRIBUTES(state, data) {
            state.topSortAttributes = data
        },
        SET_SORT(state, data) {
            state.sort = data
        },
    },
    
}